export const bookInfoRo = {
  title: "Trezirea Cuantică",
  subtitle: "O Cronică a Ascensiunii Umane",
  author: "Andrei Ciomîrtan",
  coverImage: "https://media-manager-c.questera.ai/greta-media/ae05bbc051fb17176d2c348bf77438a7a494626431a725f22ebe70ac4579d949c16512ea83019a888cf26e0e50680ce7/images/aW1hZ2UvanBlZw==/b5a489e59824de376ec7261de27bf74c.jpg",
  authorImage: "https://media-manager-c.questera.ai/greta-media/ae05bbc051fb17176d2c348bf77438a7a494626431a725f22ebe70ac4579d949c16512ea83019a888cf26e0e50680ce7/images/aW1hZ2UvanBlZw==/91ab01df2fc17bd64fc03588a793bcb6.jpg",
  overallArc: "Cartea evoluează de la supraviețuire → expansiune → reflecție → transcendență, urmărind călătoria umanității de la aproape distrugerea lumii sale natale până la a deveni o specie multi-planetară, care atinge spațiul interstelar — rănită, mai înțeleaptă și încă îndreptată spre exterior.",
  closingQuote: "Ascensiunea nu este o destinație. Este o mișcare. Este direcția, nu sosirea. Suntem încă în ascensiune.",
  links: {
    amazon: {
      kindle: "https://www.amazon.com/dp/B0GXDZXVNV",
      paperback: "https://www.amazon.com/dp/B0GXKS9ZSV",
      hardcover: "https://www.amazon.com/dp/B0GXK8VRZJ"
    },
    website: {
      en: "https://ciomirtan.com/book/the-quantum-awakening-a-chronicle-of-humanitys-ascension/",
      ro: "https://ciomirtan.com/book/trezirea-cuantica-o-cronica-a-ascensiunii-umane/"
    }
  }
};

export const chaptersRo = [
  {
    num: 1,
    title: "Trezirea Cuantică",
    era: "2067–2075",
    world: "Pământ / Zürich",
    desc: "Povestea începe cu primul salt al umanității în calculul cuantic și inteligența artificială, într-un laborator din Zürich. O pandemie letală (Marburg-X) ucide 340 de milioane de oameni în trei ani. Acest capitol stabilește natura duală a epocii — salturi tehnologice extraordinare alături de suferință umană catastrofală.",
    color: "from-blue-900/30 to-brand-dark"
  },
  {
    num: 2,
    title: "Mercur: Forja Civilizației",
    era: "2110–2200",
    world: "Mercur",
    desc: "Prima bază permanentă a umanității în sistemul solar interior. Mercur devine motorul industrial al civilizației — o lume a extremelor, folosită pentru captarea energiei solare și extragerea materialelor rare. Viața este definită de zona terminatorului, unde coloniștii urmăresc banda îngustă dintre căldura arzătoare și întunericul înghețat.",
    color: "from-orange-900/30 to-brand-dark"
  },
  {
    num: 3,
    title: "Venus: Lumea Renăscută",
    era: "2290–2501",
    world: "Venus",
    desc: "Cel mai detaliat și mai bogat vizual capitol. De la 2290 la 2501, el cronichează terraformarea completă a Venusului — implementarea Parasolarului Ishtar, 97 de ani de livrare a gheții de pe lunile lui Jupiter, crearea a trei oceane și construcția unei magnetosfere artificiale. Până în 2501, Venus este un paradis cald, cu cer ambrat și o populație de un milion.",
    color: "from-amber-900/30 to-brand-dark"
  },
  {
    num: 4,
    title: "Pământul: Mama Rănită",
    era: "2058–2350",
    world: "Pământ",
    desc: "Cel mai greu capitol de citit. O cronică sobră a colapsului Pământului — schimbări climatice care depășesc 2,8°C, moartea recifelor de corali, Amazonia transformată în savană, colaps agricol și strămutarea a 2 miliarde de refugiați climatici. Povestit prin povești individuale, nu statistici, este un capitol al suferinței inutile și al răscumpărării obținute cu greu.",
    color: "from-green-900/30 to-brand-dark"
  },
  {
    num: 5,
    title: "Marte: Republica Roșie",
    era: "2180–2400",
    world: "Marte",
    desc: "Marte apare ca prima civilizație planetară cu adevărat independentă a umanității — curajoasă politic, distinctă cultural și dedicată filosofic autoguvernării. Capitolul urmărește arcul de la primele cupole de terraformare până la o republică marțiană pe deplin formată.",
    color: "from-red-900/30 to-brand-dark"
  },
  {
    num: 6,
    title: "Centura: Oamenii Liberi",
    era: "2220–2450",
    world: "Centura de Asteroizi",
    desc: "Centura de Asteroizi devine căminul unei civilizații unice și feroce independente de mineri, comercianți și rătăcitori. Centurenii își dezvoltă propriul limbaj creol plin de metafore navigaționale, propriile coduri sociale și o cultură construită în jurul mișcării, lipsei și autoîntreținerii.",
    color: "from-gray-700/30 to-brand-dark"
  },
  {
    num: 7,
    title: "Jupiter: Copiii Gigantului",
    era: "2260–2420",
    world: "Sistemul Jupiter",
    desc: "Umanitatea se stabilește în sistemul jovian — lunile Europa, Ganymede și Callisto. Lunile de gheață devin surse de apă care au alimentat terraformarea Venusului. Capitolul explorează minunile inginerești ale accesului la oceanele subterane de pe Europa.",
    color: "from-yellow-900/30 to-brand-dark"
  },
  {
    num: 8,
    title: "Saturn: Catedrala Inelată",
    era: "2310–2470",
    world: "Saturn / Titan",
    desc: "Lunile lui Saturn, în special Titan cu atmosfera sa groasă de azot și lacurile de hidrocarburi, devin un centru cultural improbabil — un loc al artiștilor, filosofilor și al celor atrași de frumusețea sublimă. Viața pe Titan este lentă, contemplativă și profund estetică.",
    color: "from-purple-900/30 to-brand-dark"
  },
  {
    num: 9,
    title: "Neptun: Frontiera Albastră Adâncă",
    era: "2418–2510",
    world: "Neptun / Triton",
    desc: "Cea mai îndepărtată așezare permanentă umană: Stația Triton, fondată în 2418 pe cea mai mare lună a lui Neptun. La -235°C, ingineria de aici împinge știința materialelor la limitele absolute. Neptunenii dezvoltă o cultură tăcută, răbdătoare, de santinelă.",
    color: "from-blue-950/50 to-brand-dark"
  },
  {
    num: 10,
    title: "Pactul Gaia: O Specie Renăscută",
    era: "2480–2510",
    world: "Sistemul Solar",
    desc: "Un capitol de cotitură care privește umanitatea ca întreg. Pactul Gaia este cadrul politic și filosofic care leagă civilizația solară împreună — născut din lecțiile aproape-distrugerii Pământului. Acest capitol este despre memoria colectivă și responsabilitate.",
    color: "from-teal-900/30 to-brand-dark"
  },
  {
    num: 11,
    title: "Odiseea: Primul Pas al Umanității spre Stele",
    era: "2514",
    world: "Interstelar",
    desc: "Capitolul final triumfal. Umanitatea lansează prima sa misiune interstelară — Odiseea — spre Alpha Centauri. Și apoi, exact când nava pleacă, un semnal sosește din spațiul profund. Inexplicabil. Deliberat. Cronica se termină deliberat neterminată — următorul capitol este al nostru de scris.",
    color: "from-indigo-900/30 to-brand-dark"
  }
];

export const familiesRo = [
  {
    name: "Vasquez",
    origin: "Zürich / Pământ",
    desc: "Începând cu Dr. Elena Vasquez, al cărei procesor cuantic a aprins trezirea, această linie poartă povara și darul invenției de-a lungul generațiilor.",
    accent: "text-amber-400"
  },
  {
    name: "Tanaka",
    origin: "Mercur / Sistemul Interior",
    desc: "Ingineri și industriași forjați în cuptorul zonelor terminatoare ale lui Mercur, Tanaka au construit infrastructura care a alimentat o civilizație solară.",
    accent: "text-orange-400"
  },
  {
    name: "Osei-Okonkwo",
    origin: "Pământ / Venus",
    desc: "De la Kinshasa la țărmurile ambrate ale Venusului terraformat, povestea acestei familii cuprinde cea mai întunecată oră a Pământului și cea mai frumoasă răscumpărare a umanității.",
    accent: "text-green-400"
  },
  {
    name: "Rivera-Mwangi",
    origin: "Neptun / Interstelar",
    desc: "Culminând cu Eseosa Rivera-Mwangi, directorul Observatorului Heliopausei din Neptun, această linie stă la marginea tuturor — ascultând.",
    accent: "text-blue-400"
  }
];

export const keyMomentsRo = [
  { year: "2067", event: "Pandemia Marburg-X începe", detail: "340 de milioane de vieți pierdute în trei ani" },
  { year: "2071", event: "Dr. Elena Vasquez creează primul procesor cuantic stabil", detail: "Scânteia Trezirii Cuantice" },
  { year: "2110", event: "Prima colonie pe Mercur înființată", detail: "Prima casă permanentă a umanității în afara Pământului" },
  { year: "2180", event: "Terraformarea lui Marte începe", detail: "Primele cupole urbane răsar în deșerturile roșii" },
  { year: "2290", event: "Terraformarea Venusului inițiată", detail: "Parasolar Ishtar implementat" },
  { year: "2418", event: "Stația Triton fondată", detail: "Umanitatea ajunge la Neptun, -235°C" },
  { year: "2480", event: "Pactul Gaia semnat", detail: "Opt lumi legate de un legământ" },
  { year: "2501", event: "Venus declarat paradis", detail: "Populație: un milion, ceruri ambrate și oceane calde" },
  { year: "2514", event: "Proiectul Odiseea lansează", detail: "Prima misiune interstelară cu echipaj spre Alpha Centauri" },
  { year: "2514", event: "Semnalul detectat", detail: "O transmisie recursivă, auto-referențială din spațiul profund" }
];